import React, { useEffect, useState } from "react";
import Image from "./Image";
import PDF from "./PDF";
import { useLocation } from "react-router-dom";
import { fetchCandidateDetails } from "src/Services/Candidate/CandidateService";
import {
  fetchQuestions,
  submitReview,
  updateReviewStatus,
} from "src/Services/Question/QuestionService";
import { GetDisplayQuestions } from "src/Services/Question/GetDisplayQuestions";
import Sidebar from "../Button/Sidebar";
import { loadingState } from "src/atom/LoadingState";
import { useRecoilState } from "recoil";
import Keywords from "./Keywords";

const CandidateDetail = () => {
  const [activeIndices, setActiveIndices] = useState([]);
  const [modalData, setModalData] = useState({ disable: false });
  const [loader, enableLoader] = useRecoilState(loadingState);
  const location = useLocation();
  const { id } = location.state || {};
  const { group } = location.state || {};
  const [details, setDetails] = useState({});
  const [questions, setQuestions] = useState([]);
  const [review, setReview] = useState({});
  const [status, setStatus] = useState("NS");
  const [validationErrors, setValidationErrors] = useState({});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleInputChange = (event) => {
    const { name, value, type, options } = event.target;
    setReview((prevFormData) => ({
      ...prevFormData,
      [name]:
        type === "select-multiple"
          ? Array.from(options)
              .filter((option) => option.selected)
              .map((option) => option.value)
          : value,
    }));
  };

  const toggleAccordion = (index) => {
    const newActiveIndices = [...activeIndices];
    newActiveIndices[index] = !newActiveIndices[index];
    setActiveIndices(newActiveIndices);
  };

  const openAllAccordions = () => {
    setActiveIndices(activeIndices.map(() => true));
  };

  const closeAllAccordions = () => {
    setActiveIndices(activeIndices.map(() => false));
  };

  const fetchDetailsAPICall = async () => {
    var fetchDetailsMethod = async () => {
      var response = await fetchCandidateDetails(id, group);
      if (response.success) {
        setDetails(response.body);
        var anyBoxesChecked = new Array(
          response.body.candidate?.documents?.length
        ).fill(false);
        setActiveIndices(anyBoxesChecked);
        setReview(response.body?.verified_data);
        setStatus(response.body?.verification_status);
        if (response.body?.verification_status == "NS") {
          await updateReviewStatus(id, { verification_status: "IP" });
          setStatus("IP");
        }
      } else {
        //error
      }
      var response = await fetchQuestions(group);
      if (response.success) {
        setQuestions(response.body);
        setModalData({
          display: true,
          questions: response.body,
          handleInputChange: handleInputChange,
        });
      } else {
        //error
      }
    };
    fetchDetailsMethod();
  };

  useEffect(() => {
    fetchDetailsAPICall();
  }, []);

  const handleSubmit = async () => {
    setValidationErrors({});
    enableLoader(true);
    var display_questions = GetDisplayQuestions(questions, review);
    var output = {};
    var validation_errors = {};

    for (const question of questions) {
      if (display_questions.includes(question.id)) {
        if (question.is_mendatory && !review[question.id]) {
          validation_errors[question.id] =
            "validation error: " + question.label;
        }
        output[question.id] = review[question.id];
      }
    }
    if (JSON.stringify(validation_errors) === "{}") {
      if (status == "IP") {
        var response = await submitReview({ id: id, verified_data: output });
        await updateReviewStatus(id, { verification_status: "R" });
        setStatus("R");
      }
    } else {
      setValidationErrors(validation_errors);
      enableLoader(false);
    }
    enableLoader(false);
  };

  return (
    <>
      {isSidebarOpen == false && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "fixed",
            top: "110px",
            right: "40px",
            zIndex: 1000,
          }}
        >
          <button className="btn btn-sm btn-success" onClick={toggleSidebar}>
            Review
          </button>
        </div>
      )}
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        modalData={modalData}
        review={review}
        validationErrors={validationErrors}
      />
      <div
        className="card"
        style={{
          marginRight: isSidebarOpen ? "350px" : "0",
          transition: "margin-left 0.3s",
        }}
      >
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th colSpan={4} className="text-center">
                    Candidate Details
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style={{ width: "25%" }}>Application Id</th>
                  <td>{details?.candidate?.transaction_id}</td>
                  <th>Name</th>
                  <td>{details?.candidate?.name}</td>
                </tr>
                <tr>
                  <th>Father Name</th>
                  <td>{details?.candidate?.father_name}</td>
                  <th>Mother Name</th>
                  <td>{details?.candidate?.mother_name}</td>
                </tr>
                <tr>
                  <th>DOB</th>
                  <td>{details?.candidate?.dob}</td>
                  <th>Gender</th>
                  <td>{details?.candidate?.gender}</td>
                </tr>
                <tr>
                  <th>Category</th>
                  <td>{details?.candidate?.caste}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div id="accordion">
            <button
              className="btn btn-sm btn-primary mb-3"
              onClick={openAllAccordions}
            >
              Expand All
            </button>
            <button
              className="btn btn-sm btn-primary mb-3 ms-2"
              onClick={closeAllAccordions}
            >
              Close All
            </button>

            {details.candidate?.documents.map((document, index) => (
              <>
                <div className="card mb-2" key={index}>
                  <div className="card-header" id="headingOne">
                    <button
                      className="btn btn-link"
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={activeIndices[index]}
                      aria-controls="collapseOne"
                    >
                      {document.type}
                    </button>
                  </div>
                  <div
                    id="collapseOne"
                    className={`collapse ${activeIndices[index] ? "show" : ""}`}
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    {document.file.slice(-3).toLowerCase() == "pdf" ? (
                      <PDF file={document.id} />
                    ) : (
                      <Image file={document.id} />
                    )}
                  </div>
                  <Keywords ocr_results={document.ocr_results} />
                </div>
              </>
            ))}
          </div>
          {status == "IP" && (
            <button
              type="button"
              className="btn btn-sm btn-success ms-1 mt-2"
              onClick={() => handleSubmit()}
              style={{ textDecoration: "none" }}
            >
              Submit
            </button>
          )}
        </div>
        <ul>
          {Object.entries(validationErrors).map(([key, value]) => (
            <li key={key}>{value}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default CandidateDetail;
